import { render, staticRenderFns } from "./SuperadminDataTable.vue?vue&type=template&id=00699e76&scoped=true"
import script from "./SuperadminDataTable.vue?vue&type=script&lang=js"
export * from "./SuperadminDataTable.vue?vue&type=script&lang=js"
import style0 from "./SuperadminDataTable.vue?vue&type=style&index=0&id=00699e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00699e76",
  null
  
)

export default component.exports